import type { Component } from 'solid-js'
import type { DivProps } from '../ui/utils-ui'
import { Logger } from 'besonders-logger'
import { createMemo, Show } from 'solid-js'
import { ApplogView } from '../components/ApplogView'
import { ResourceSpinner } from '../components/mini-components'
import { useSingleUrlParam } from '../ui/utils-ui'
import { usePreviewResource } from '../ui/use-preview-resource'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.DEBUG) // eslint-disable-line unused-imports/no-unused-vars

export const InspectPage: Component<DivProps & {}> = (restProps) => {
	const pubFromUrl = createMemo(() => useSingleUrlParam('share')[0]() || useSingleUrlParam('pub')[0]() || useSingleUrlParam('preview')[0]())

	// const appThread = useRawThread()
	const [subResource, { refetch }] = usePreviewResource(() => pubFromUrl())
	const subData = createMemo(() => pubFromUrl() && subResource.state === 'ready' && subResource())

	const errorMessage = createMemo(() => subResource.error?.message || '')

	return (
		<div>
			<Show when={errorMessage()}>
				<div style={{ padding: '1rem', margin: '1rem 0', border: '1px solid #e2785a', 'border-radius': '8px', background: '#2a1a14', color: '#e2785a' }}>
					<div style={{ 'font-weight': 'bold', 'margin-bottom': '0.5rem' }}>Failed to load publication</div>
					<div style={{ color: '#ccc' }}>{errorMessage()}</div>
				</div>
			</Show>
			<ResourceSpinner resource={subResource}>
				<Show when={subData()?.thread} fallback='No data - check ?share or ?pub in URL'>
					<ApplogView
						thread={subData().thread}
						alwaysOpen={true}
						{...restProps}
					/>
				</Show>
			</ResourceSpinner>
			<pre mt-12 style={{ 'font-size': '10px' }}>{JSON.stringify(subResource(), undefined, 4)}</pre>
		</div>
	)
}
